export class PostcodeLookup {
  fullAddress = {}

  searchPostcode(postcode, postcodeLookUpToken, postcodeLookupRef) {
    const self = this // create reference to this object to use in the success function
    this.fullAddress = {
      Address1: '',
      Address2: '',
      Town: '',
      County: '',
      Postcode: ''
    }
    this.addressOptions = [] // array to hold the address options
    $.ajax({
      type: 'GET',
      url: '/postcode-lookup',
      data: { sPostcode: postcode, sToken: postcodeLookUpToken, sRef: postcodeLookupRef },
      cache: true,
      success: function (jsonResults) {
        self.displayResults(jsonResults)
      }
    })
  }

  lookupError(errorMessage) {
    $('#lookup-results .form-group').addClass('has-error')
    $('#lookup-status').html(errorMessage)
  }

  displayResults(jsonResults) {
    const oResults = JSON.parse(jsonResults)

    if (typeof oResults.getAddressResult === 'undefined') {
      return this.lookupError(oResults.error)
    }

    const getAddressResult = oResults.getAddressResult
    if (getAddressResult.ErrorMessage.length) {
      return this.lookupError(getAddressResult.ErrorMessage)
    }

    const addressKeys = Object.keys(this.fullAddress)

    addressKeys.forEach(key => {
      if (typeof getAddressResult[key] !== 'undefined') {
        this.fullAddress[key] = getAddressResult[key]
      }
    })

    if (Object.hasOwn(getAddressResult, 'Address3')) {
      this.fullAddress.Address2 += ', ' + getAddressResult.Address3
    }

    if (Object.hasOwn(getAddressResult, 'Address4')) {
      this.fullAddress.Address2 += ', ' + getAddressResult.Address4
    }

    const premisesData = getAddressResult.PremiseData.split(';')

    premisesData.forEach(premise => {
      const premiseData = premise.split('|')
      if (premiseData.length !== 3) {
        return
      }
      const thisAddressParts = []
      premiseData.forEach(data => {
        if (data.length) {
          thisAddressParts.push(data)
        }
      })
      const addressLine = thisAddressParts.join(', ') + ' ' + getAddressResult.Address1
      this.addressOptions.push(addressLine)
    })
    // create the select element
    const selectOptionsHTML = []
    if (this.addressOptions.length) {
      selectOptionsHTML.push('<option value="PS">Please select</option>')
      this.addressOptions.forEach((address, index) => {
        selectOptionsHTML.push('<option value="' + index + '">' + address + '</option>')
      })
      $('#lookup-addresses').html(selectOptionsHTML)
      $('#lookup-addresses').show()
      $('#lookup-status').hide()
    }
  }

  getAddressOptions() {
    return this.addressOptions
  }

  getFullAddress() {
    return this.fullAddress
  }

  setupFormListeners() {
    const self = this // create reference to this object to use in the success function
    // change enter key on the postcode lookup area to fire the function and not submit the whole form
    $('body').on('keypress', '#postcode_lookup', function (e) {
      if (e.key === 'Enter' || e.which === 13) {
        e.preventDefault()
        $('#postcodeLookupButton').trigger('click')
      }
    })

    $('body').on('click', '#postcodeLookupButton', function (e) {
      e.preventDefault()
      const $postcodeLookup = $('#postcode_lookup')
      const postcode = $postcodeLookup.val()
      const postcodeLookUpToken = $postcodeLookup.attr('data-lookup-token')
      const postcodeLookupRef = $postcodeLookup.attr('data-postcodeLookupRef')
      $('#lookup-results').show()
      $('#lookup-status').html('<img src="/dist/images/ajax-loader.gif" /> Loading')
      $('#lookup-results .form-group').removeClass('has-error')
      $('#lookup-status').show()
      $('#lookup-addresses').hide()
      self.searchPostcode(postcode, postcodeLookUpToken, postcodeLookupRef)
    })

    $('body').on('change', '#lookup-addresses', function (e) {
      const addresses = self.getAddressOptions()
      const fullAddress = self.getFullAddress()
      const $lookupAddresses = $('#lookup-addresses')
      const selectedValue = $lookupAddresses.val()
      const addressParts = {
        address1: '',
        address2: '',
        town: '',
        county: '',
        postcode: ''
      }
      if (selectedValue !== 'PS') {
        addressParts.address1 = addresses[selectedValue]
        addressParts.address2 = fullAddress.Address2
        addressParts.town = fullAddress.Town
        addressParts.county = fullAddress.County
        addressParts.postcode = fullAddress.Postcode
      }
      $('#address1').val(addressParts.address1)
      $('#address2').val(addressParts.address2)
      $('#town').val(addressParts.town) // @todo change this to addTown on customer details page
      $('#addTown').val(addressParts.town)
      $('#county').val(addressParts.county) // @todo change this to addCounty on customer details page
      $('#addCounty').val(addressParts.county)
      $('#postcode').val(addressParts.postcode) // @todo change this to addPostcode on customer details page
      $('#addPostcode').val(addressParts.postcode)
      $('#countryId').val(82)
    })
  }
}
